export default __webpack_public_path__ + "static/media/level3.4c9016dd.svg";